import React from 'react';
import {
  Button,
  createStyles,
  makeStyles,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import WarningIcon from '@material-ui/icons/Warning';
import { SupportContacts } from './SupportContacts';
import { cleanBillingError } from 'actions/billingErrors';
import { useAppDispatch } from 'combineReducers';

const useStyles = makeStyles(() =>
  createStyles({
    titleWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    subtitle: {
      whiteSpace: 'pre-line'
    },
    action: {
      display: 'flex',
      justifyContent: 'flex-start',
      padding: '0 0 20px'
    }
  })
);

type Strings = {
  title: string;
  subtitle: string;
  description: string;
  action: string;
};

interface Props {
  onClose(): void;
}

export const OverlayError: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const strings: Strings = {
    title: t('subscriber:overlayError.title', 'Payment System Error Occurred'),
    subtitle: t(
      'subscriber:overlayError.subtitle',
      `We are experiencing temporary technical issues.
    Please try again later.`
    ),
    description: t(
      'subscriber:overlayError.description',
      'You can also contact our Customer Support for any details and assistance in establishing connection request.'
    ),
    action: t('subscriber:overlayError.action', 'Back to the company profile')
  };

  const handleClose = () => {
    onClose();
    dispatch(cleanBillingError());
  };

  return (
    <>
      <DialogTitle>
        <div className={classes.titleWrapper}>
          <WarningIcon color="error" />
          {strings.title}
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.subtitle}>{strings.subtitle}</DialogContentText>
        <DialogContentText>{strings.description}</DialogContentText>
        <SupportContacts />
        <DialogActions className={classes.action}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            {strings.action}
          </Button>
        </DialogActions>
      </DialogContent>
    </>
  );
};
